import { Loader2 } from "lucide-react";

export default function LoadingScreen({ label = "Memuat..." }) {
  return (
    <div className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-3" data-testid="loading-screen">
      <Loader2 className="h-8 w-8 animate-spin text-[#0F6B4F]" />
      <p className="text-sm text-[#64748B]">{label}</p>
    </div>
  );
}
